import React, { useState, useEffect } from 'react';

const useInstance = () => {
  const [selectedInstance, setSelectedInstance] = useState({});
  const [instance, setInstance] = useState({});

  useEffect(() => {
    const instanceL = JSON.parse(localStorage.getItem('instance'));
    const selectedInstanceL = JSON.parse(
      localStorage.getItem('selectedInstance'),
    );
    setInstance(instance);
    setSelectedInstance(
      selectedInstanceL?.length > 0 ? selectedInstanceL[0] : instanceL[0],
    );
  }, []);
  return selectedInstance;
};

export { useInstance };
